import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id, pagination }) => {
        const { page, pageSize: limit } = pagination;
        try {
            const [statusesRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listStatuses', {
                    query,
                    limit,
                    page
                }),
                Request.postJSON('admin/project/listStatuses', {
                    id: id === undefined ? [] : id
                })
            ]);

            if (statusesRes.error || selectedRes.error) {
                throw new Error(statusesRes.msg || selectedRes.msg);
            }

            const statuses = { data: statusesRes.data, count: statusesRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = statuses.data.find(
                    itemStatus => itemStatus.id === itemSelected.id
                );
                if (!item) {
                    statuses.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return statuses;
        } catch (err) {
            console.error(err);
        }
    }
};
